import {ListGroup} from "react-bootstrap";
import * as React from "react";
import {CorrespondenceModel} from "../../../../../models/domain/correspondenceModel";
import { FaPlusCircle } from "react-icons/fa";

export const ArticlesAndGuides = ({
                                      model: {
                                          title,
                                          hasResources,
                                          resourceCount,
                                          resources,
                                          moreToShow,
                                          showAll
                                      }
                                  }: {
    model: {
        title: string;
        hasResources: boolean;
        resourceCount: number;
        resources: CorrespondenceModel[];
        moreToShow: boolean;
        showAll: () => void;
    };
}) => {
    // If there are no articles or guides, return an empty fragment
    if (!hasResources) return <></>;

    return (
        <>
            <ListGroup variant="flush" className="mt-0">
                <ListGroup.Item className="bg-light border-top">
                    <strong>
                        {title}
                    </strong>
                </ListGroup.Item>
                {resources.map(({title, path}, index) => (
                    <ListGroup.Item action href={path} className="text-info" key={index}>
                        {title}
                    </ListGroup.Item>
                ))}
                {moreToShow && (
                    <ListGroup.Item onClick={showAll} action className="text-info d-flex align-items-center">
                        <FaPlusCircle className="me-1" aria-hidden/>Show all {resourceCount} {title}
                    </ListGroup.Item>
                )}
            </ListGroup>
         </>
    );
};